module.exports = __webpack_public_path__ + "img/Group 360.8fcabdc6.svg";